<div class="w-full">
  <div class="modal-header">
    <div class="flex flex-col justify-center items-center">
      <h4 class="paragraph-large bold mb-6">{{ 'balance.shareGanasHeader' | translate }}</h4>
    </div>
  </div>
  <div class="flex flex-col justify-start">
    <div class="relative px-2 md:px-3 scrollable-area">
      <p class="paragraph-medium regular mb-8 text-center">
        {{ 'balance.toShareGanas' | translate }}
        <b class="medium">{{ 'balance.activeUniGanaMember' | translate }}</b
        >{{ 'balance.notJustInTheReferral' | translate }}
        <b class="medium">{{ 'balance.nameOrPhoneNumber' | translate }}</b>
        {{ 'balance.withinYourNetwork' | translate }}
        <a (click)="openSendInviteModal()" class="underline invite-them">{{ 'balance.inviteThem' | translate }}</a>
        {{ 'balance.toJoinOurCommunity' | translate }}
      </p>
      <div class="mb-2">
        <korviu-multi-select
          label="{{ 'balance.nameOrPhone' | translate }}"
          [serverSearch]="true"
          [searchFn]="onSharePeopleSearch.bind(this)"
          [(currentSelectValue)]="selectedGanamigo"
          [dropdownLabelFormatFn]="dropdownLabelFormatFn.bind(this)"
          #ganamigoSelect
        ></korviu-multi-select>
      </div>
      <div class="mb-2">
        <korviu-input
          type="text"
          label="{{ 'balance.amountOfGanas' | translate }}"
          [control]="amountTosendControl"
          [onlyNumbers]="true"
          [showErrorMessagesUnderField]="true"
          [errorMessagesUnderField]="[{ errorCode: 'valueGreaterThanMax', localizedMessage: 'balance.youExceeded' }]"
          id="share-ganas-amount-input"
        ></korviu-input>
        @if (!balanceIsLoading && isInDeficit()) {
          <p class="paragraph-small text-danger mt-2 mb-0" role="alert">
            {{ 'balance.ganasDeficitMessage' | translate: { deficit: deficitGanas() | thousandsSeparator } }}
          </p>
        }
      </div>
      <span class="paragraph-medium bold my-6 block">{{ 'balance.recentGanamigos' | translate }}</span>
      <div class="flex flex-col gap-4 p-2">
        @if (recentGanamigosIsLoading) {
          <korviu-loader></korviu-loader>
        }
        @if (!recentGanamigosIsLoading) {
          @if (!recentGanamigos?.length) {
            <korviu-no-data></korviu-no-data>
          }
          @if (recentGanamigos?.length) {
            @for (user of recentGanamigos; track user.id) {
              <div
                class="flex items-center gap-4 recent-ganamigo"
                [class.selected]="user.id === selectedGanamigo"
                (click)="onGanamigoClick(user)"
              >
                <nz-avatar
                  class="paragraph-medium medium flex flex-col items-center justify-center"
                  [nzSize]="40"
                  [nzText]="getUserNameForAvatar(user?.userObj?.full_name)"
                  [nzSrc]="user?.avatarUrl"
                ></nz-avatar>
                <div class="flex flex-col paragraph-medium regular">
                  <span class="recent-full-name">{{ user?.userObj?.full_name || '-' }}</span>
                  <span class="recent-full-name light"
                    >{{ 'myGanarbols.levelId' | translate }}{{ user.levelNumber }}
                    {{ user?.userObj?.status || user.typeName }}</span
                  >
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
  <div class="modal-footer" *nzModalFooter>
    <div class="flex justify-end gap-4">
      <korviu-button type="button" color="ghost" (click)="onCancel()" class="w-full">
        {{ 'common.cancel' | translate }}
      </korviu-button>
      <korviu-button color="tertiary" class="w-full" [disabled]="shareButtonDisabled" (click)="onShareClick()">
        {{ 'common.share' | translate }}
      </korviu-button>
    </div>
  </div>
</div>
